import { FormattedMessage } from 'react-intl'
import { Box, Tooltip, styled, alpha } from '@mui/material'

import { Typography } from '@carto/meridian-ds/components'
import { User } from 'features/users'

import AccountIcon from 'assets/icons/places-corporate-fare.svg?react'

const AccountIconWrapper = styled('div')(({ theme }) => ({
  width: theme.spacing(4.5),
  height: theme.spacing(4.5),
  borderRadius: '50%',
  backgroundColor: alpha(theme.palette.secondary.main, 0.12),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1.25),
  '& path': {
    fillOpacity: 1,
    fill: theme.palette.secondary.dark
  }
}))

const Account = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  paddingTop: theme.spacing(1.25),
  display: 'flex',
  alignItems: 'center'
}))

export default function UserAccount({ user }: { user?: User }) {
  return (
    <Account aria-label="User account">
      <AccountIconWrapper>
        <AccountIcon />
      </AccountIconWrapper>
      <Tooltip placement="top" title={<FormattedMessage id="common.logout.account" />} arrow>
        <Typography variant="body2" color="textPrimary" noWrap={true} weight="strong">
          {user?.user_metadata?.account_name || '-'}
        </Typography>
      </Tooltip>
    </Account>
  )
}
